// services/projectApi.js
import { apiSlice } from "services/apiSlice";

export const projectApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // récupérer tous les projets
    getProjects: builder.query({
      query: () => "projects",
      providesTags: ["Projects"],
    }),
    getProjectsByCompany: builder.query({
      query: (companyId) => `projects/company/${companyId}`,
      providesTags: ["Projects"],
    }),
    // récupérer un projet par ID
    getProjectById: builder.query({
      query: (id) => `projects/${id}`,
      providesTags: ["Projects"],
    }),

    // récupérer tous les projets d’un collaborateur
    getProjectsByCollaborator: builder.query({
      query: (collaboratorId) => `projects/collaborator/${collaboratorId}`,
      providesTags: ["Projects"],
    }),

    // récupérer tous les projets d’un fournisseur
    getProjectsBySupplier: builder.query({
      query: (supplierId) => `projects/supplier/${supplierId}`,
      providesTags: ["Projects"],
    }),

    // créer un projet
    createProject: builder.mutation({
      query: (formData) => ({
        url: "projects",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Projects"],
    }),

    // mettre à jour un projet
    updateProject: builder.mutation({
      query: ({ projectId, data }) => {
        const isFormData = data instanceof FormData;

        return {
          url: `projects/${projectId}`,
          method: "PATCH",
          body: data,
          headers: isFormData ? {} : { "Content-Type": "application/json" },
        };
      },
      invalidatesTags: ["Projects"],
    }),

    // supprimer un projet
    deleteProject: builder.mutation({
      query: (id) => ({
        url: `projects/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Projects"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetProjectsQuery,
  useGetProjectByIdQuery,
  useGetProjectsByCompanyQuery,
  useGetProjectsByCollaboratorQuery,
  useGetProjectsBySupplierQuery,
  useCreateProjectMutation,
  useUpdateProjectMutation,
  useDeleteProjectMutation,
} = projectApi;
